module.exports = require("xml");


//////////////////
// WEBPACK FOOTER
// external "xml"
// module id = 475
// module chunks = 0